import React from 'react';
import './Galary.css'
import img1 from '../../../assets/img/gallary/galary-1.png'
import img2 from '../../../assets/img/gallary/galary-2.png'
import img3 from '../../../assets/img/gallary/galary-3.jpg'
import img4 from '../../../assets/img/gallary/galary-4.png'
import img5 from '../../../assets/img/gallary/galary-5.jpg'
import img6 from '../../../assets/img/gallary/galary-6.png'
import bgImg from '../../../assets/img/bg-2.png'
import { Link } from 'react-router-dom';
const gallaryImg = [
    {
        id: 1,
        image: img1,
        info: 'Beautiful Sea'
    },
    {
        id: 2,
        image: img2,
        info: 'Beautiful Sea with beatch'
    },
    {
        id: 3,
        image: img3,
        info: 'Wedding Photography'
    },
    {
        id: 4,
        image: img4,
        info: 'Anniversary Photography'
    },
    {
        id: 5,
        image: img5,
        info: 'Wedding Photography'
    },
    {
        id: 6,
        image: img6,
        info: 'Sea with board'
    },
]
const Galary = () => {
    return (
        <div className='my-8'>
            <h1 className='text-5xl mb-5 text-center'>Gallary</h1>
            <div className="grid lg:grid-cols-3 gap-4 mx-auto w-full">
                {
                    gallaryImg.map(img => <div key={img.id} className="indicator mx-auto">
                        <img src={img.image} className='w-80 h-auto rounded-lg' />
                        <span className="indicator-item indicator-center top-1/2 w-full text-center text-2xl">{img.info}</span>
                    </div>)
                }
            </div>
            <div className="hero min-h-screen bg-base-200 mt-5">
                <div className="hero-content flex-col lg:flex-row-reverse">
                    <img src={bgImg} className='w-full'/>
                    <div>
                        <h1 className="text-5xl font-bold">You can sign up a time for Wedding photography today!</h1>
                        <p className="py-6">Gift For Photography Lovers In Beautiful Archival Box With Certificate Of Authenticity. Fine Art Photography.</p>
                        <Link to='/signup'><button className="btn btn-primary">Get Started</button></Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Galary;